import React, { useRef, useState, useEffect } from 'react';
import RagnaDataTable from '../ReactComponents/RagnaDataTable.jsx';
import axios from 'axios';
import { ajax_api, getAccess } from '../../Globals.jsx';
import { useOutlet, Outlet, useOutletContext } from 'react-router-dom';
import RagnaWindow from '../ReactComponents/RagnaWindow';
import RagnaModal from '../ReactComponents/RagnaModal';
import { useForm } from 'react-hook-form';
import { MultiSelect } from '../ReactComponents/MultiSelect.jsx';
import Select from 'react-select';
import { Helmet } from 'react-helmet';
import RagnaLoader from '../ReactComponents/RagnaLoader.jsx';

const CouncilOfficials = props => {
    //datatable options
    const [refreshTable] = useOutletContext();
    const [refreshMain, setRefreshMain] = useState(-1);

    const table_columns = [
        { display: "Name", col: "Name" },
        { display: "Type", col: "Type" },
        { display: "Status", col: "Status", dontOrder: true },
    ];
    const search_columns = [
        { display: "Name", col: "Name" }
    ];
    const outlet = useOutlet();
    const editInput = useRef(null);

    const [council, setCouncil] = useState(-1);
    const [councils, setCouncils] = useState([]);
    const [loaded, setLoaded] = useState(false);
    const [errorOptions, setErrorOptions] = useState("");
    const [modalOpen, setModalOpen] = useState(false);
    const [officials, setOfficials] = useState([]);
    const [types, setTypes] = useState([]);
    const [status, setStatus] = useState([]);

    const [addOfficial, setAddOfficial] = useState([]);
    const [addType, setAddType] = useState([]);
    const [addStatus, setAddStatus] = useState([]);

    useEffect(_ => {
        (async function () {
            //get officials option
            var loaded = 0;
            await axios.get(ajax_api + "items/getOption/officials/")
                .then(response => {
                    var d = response.data.map(o => (
                        {
                            label: o.label.split(" ").map(str => {
                                var initials = ["II", "III", "IV", "VI", "VII", "VIII", "VIII"];
                                if (initials.some(ii => str == ii || str + "." == ii)) return str.toUpperCase();
                                return str[0] ? (str[0].toUpperCase() + str.substring(1).toLowerCase()) : "";
                            }).join(" "), value: o.value
                        }
                    ))
                    d.sort((a, b) => a.label.toLowerCase() > b.label.toLowerCase());
                    setOfficials(d);
                    loaded++;
                }).catch(e => setErrorOptions(e));
            await axios.get(ajax_api + "items/getOption/official_types/")
                .then(response => {
                    var d = [...response.data];
                    d.sort((a, b) => a.label.toLowerCase() > b.label.toLowerCase());
                    setTypes(d);
                    loaded++;
                }).catch(e => setErrorOptions(e));
            await axios.get(ajax_api + "items/getOption/official_status/")
                .then(response => {
                    var d = [...response.data];
                    d.sort((a, b) => a.label.toLowerCase() > b.label.toLowerCase());
                    setStatus(d);
                    loaded++;
                }).catch(e => setErrorOptions(e));
            await axios.get(ajax_api + "items/getOption/councils/")
                .then(response => {
                    var d = [...response.data];
                    d.sort((a, b) => b.label.replace(/\D/g, '') - a.label.replace(/\D/g, ''));
                    setCouncils(d);
                    loaded++;
                }).catch(e => setErrorOptions(e));
            if (loaded >= 4) {
                setLoaded(true);
            }
        })();
    }, [])

    const { handleSubmit, register, watch } = useForm();

    const watchCouncil = watch("council", council);
    useEffect(() => {
        const subscription = watch((value, { name, type }) => console.log()); //value, name, type
        return () => subscription.unsubscribe();
    }, [watch]);

    const [isSaving, setIsSaving] = useState(false);

    const saveMembers = _ => {
        if (council > 0) {
            if (addOfficial > 0 && addType > 0 && addStatus > 0) {
                (async () => {
                    setIsSaving(true);

                    var f = new FormData();
                    f.append("official", addOfficial);
                    f.append("type", addType);
                    f.append("status", addStatus);

                    await axios.post(`${ajax_api}councils/save-council-members/${council}`, f, {withCredentials: true}).then(_ => {
                        setModalOpen(false)
                        setRefreshMain(r => r + 1);
                    }).catch(e => alert(e));


                    setIsSaving(false);
                })();
            } else {
                alert("Validation error. Check input for missing data.")
            }
        }
    };

    return <>
        <Helmet>
            <title>LTS | Manage Council Members</title>
        </Helmet>
        {
            outlet != null ? <Outlet /> :
                (
                    loaded == false ? <>
                        <RagnaWindow mainStyle={{marginTop:100,display:"flex",justifyContent:"center"}} boxStyle={{ minHeight:0 }}>
                            {
                                errorOptions == "" ? <>
                                    <RagnaLoader text="Loading Councils" />
                                </> : <div className="alert alert-danger">
                                        Error! {errorOptions}
                                        Click <a href="#">here</a> to try again
                                    </div>
                            }
                        </RagnaWindow>
                    </> :
                        <div className="row">
                            <div className="col-3">
                                <RagnaWindow boxStyle={{ minHeight: 0 }}>
                                    <form onSubmit={handleSubmit(e => {
                                        setRefreshMain(e => e + 1)
                                        setCouncil(e.council)
                                    })}>
                                        <select className="form-select" {...register("council")}>
                                            {
                                                councils.map((c, i) => <option value={c.value} key={i}>{c.label}</option>)
                                            }
                                        </select>
                                        <button className="ro-button mt-2 w-100">
                                            <span><i className="fa fa-sync" /> Load Table</span>
                                        </button>
                                    </form>
                                    <hr />
                                    {
                                        getAccess(40) || getAccess(41) ? 
                                        <RagnaModal 
                                            openAndThen={_ => {
                                                setAddOfficial(null);
                                                setAddStatus(null);
                                                setAddType(null);
                                            }}
                                            btnClass="w-100"
                                            btnProps={(council > 0) && (watchCouncil == council) ? {} : {disabled:true}}
                                            modalOpen={modalOpen}
                                            setModalOpen={setModalOpen}
                                            body={<>
                                                <div style={{textDecoration:"underline"}}>
                                                    Selected Council: 
                                                </div>
                                                <div> 
                                                    {councils.filter(c => c.value == council)[0]?.label}
                                                </div>
                                                <div className="mt-2" style={{ textDecoration: "underline" }}>
                                                    Official:
                                                </div>
                                                <Select value={
                                                    addOfficial > 0 ? { label: officials.filter(o => o.value == addOfficial)[0].label }
                                                        : null} onChange={d => setAddOfficial(d.value)} options={officials} />
                                                <div className="mt-2" style={{ textDecoration: "underline" }}>
                                                    Type:
                                                </div>
                                                <Select value={
                                                    addType > 0 ? { label: types.filter(o => o.value == addType)[0].label }
                                                        : null} onChange={d => setAddType(d.value)} options={types} />
                                                <div className="mt-2" style={{ textDecoration: "underline" }}>
                                                    Status:
                                                </div>
                                                <Select value={
                                                    addStatus > 0 ? { label: status.filter(o => o.value == addStatus)[0].label }
                                                        : null} onChange={d => setAddStatus(d.value)} options={status} />
                                                <hr />
                                                <div>
                                                    <button disabled={isSaving}
                                                        style={{pointerEvents:isSaving?"none":"initial"}}
                                                        className="ro-button float-end" onClick={saveMembers}>
                                                        <span>Save</span>
                                                    </button>
                                                </div>
                                            </>}
                                            trigName={<><i className="fa fa-cog" /> Manage member</> }
                                        /> : <></>
                                    }
                                </RagnaWindow>
                            </div>
                            <div className="col-9">
                            {
                                    council > 0 ? <>
                                        <RagnaDataTable
                                        key={council}
                                        refreshTable={refreshTable + refreshMain}
                                        title={`Council Officials <${councils.filter(c=>c.value==council)[0]?.label}>`}
                                    columns={table_columns}
                                    s_columns={search_columns}
                                    defaultOrder={false}
                                    maxPagination={8}
                                    generalSearch={true}
                                    defaultOrderCol="ID"
                                    url={ajax_api + "councils/get-council-officials/"+council}
                                    actions={[
                                    //    {
                                    //        action: "modal", display: "Edit",
                                    //        body: d => <>Name: <input ref={editInput} className="form-control" defaultValue={d.Name} key={d.Id} /></>, title: "Edit Data",
                                    //        footer: (d, mOpen, refresh) => <button className="ro-button" onClick={_ => {
                                    //            var form_data = new FormData();
                                    //            form_data.append("Name", editInput.current.value);
                                    //            form_data.append("Id", d.Id);

                                    //            axios.post(`${ajax_api}official-props/official-types/edit`, form_data).then(_ => {
                                    //                mOpen(false);
                                    //                refresh();
                                    //            }).catch(e => alert(e))
                                    //        }}>
                                    //            <span>Save</span>
                                    //        </button>
                                    //    },
                                        {
                                            hideIf: !getAccess(42),
                                            action: "url_confirm", display: <i className="fa fa-user-xmark"></i>,
                                            content: d => `${ajax_api}councils/council-officials/delete/${council}/${d.Id}`,
                                            body: d => <>
                                                Remove <u>{d.Name}</u> from <u>{councils.filter(c => c.value == council)[0]?.label}</u> ?
                                                
                                            </>, title: "Delete Data"
                                        },
                                    //    //{
                                    //    //    action: "modal", display: "Cust",
                                    //    //    content: d => { return { title: "title modal", body: "full name: " + d.full_name, footer: <span>footer</span> } }
                                    //    //},
                                    ]}
                                        />
                                    </> : <RagnaWindow>Please Select a Council</RagnaWindow>
                            }
                        
                        </div>
                    </div >
            )
        }
    </>
}

export default CouncilOfficials;